export const ModalDetails = {
  modalHeader: `Committee Decision`,
  modalText: `Are you sure you wish to continue to enter in a committee decision on this publication without creating a ballot?`
}
